import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SnowmobileIcon(props: IconProps) {
    return <Icon {...props} iconKey={"snowmobile"}/>
}
